import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

@Injectable()
export class RoleGuardService implements CanActivate {

  constructor(private auth:AuthService) { }

  canActivate():boolean{
    if(!this.auth.esAdmin()){
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/role-guard.service.ts